import { createElement } from "@max/max";
import LImage from "@max/leez-image";
import View from "@hfe/max-view";
import Text from "@hfe/max-text";
import { TeamRankingStatus } from "@/types/teamRanking";
import './index.scss';
import ActivityInvalid from "@/components/activity-invalid";
import { useActivitySubscription } from "@/hooks/useSubscription";
import dayjs from "dayjs";
import { TeamStageResultTheme } from "@/theme/main";
export default function TeamStageResult(props) {
    var _a, _b, _c, _d;
    const { teamInfo } = props;
    const { onSubscribe, isSubscribed } = useActivitySubscription();
    const rankingListTime = dayjs(props.rankingListTime);
    // 获取主要内容文本
    const getMainContentText = () => {
        if (props.teamRankingStatus === TeamRankingStatus.CALCULATING) {
            return '请耐心等待，最终排名计算中';
        }
        if (props.teamRankingStatus === TeamRankingStatus.WON_REWARD) {
            return <>
          全队获得
          <Text className="team-won-free-card-content-text" style={{
                color: '#111111'
            }}>
            酒店免单资格
          </Text>
        </>;
        }
        if (props.teamRankingStatus === TeamRankingStatus.PUBLICITY && (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.obtainReward)) {
            return '恭喜小队已上榜～';
        }
        return '你离免单只差一点点了～';
    };
    // 获取描述文本
    const getDescriptionText = () => {
        if (props.teamRankingStatus === TeamRankingStatus.CALCULATING) {
            return `最终的榜单将在 ${rankingListTime.format('DD日HH:mm')} 揭晓`;
        }
        if (props.teamRankingStatus === TeamRankingStatus.WON_REWARD) {
            return '恭喜你！快去下单吧～';
        }
        if (props.teamRankingStatus === TeamRankingStatus.PUBLICITY) {
            return (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.obtainReward) ? '可在奖励记录中查看上期获得的奖励' : '下期活动再来赢免单吧～';
        }
        return '下期活动再来赢免单吧～';
    };
    if (!teamInfo && props.teamRankingStatus === TeamRankingStatus.PUBLICITY) {
        return <View style={{
            display: 'flex',
            flexDirection: 'column'
        }}>
      <ActivityInvalid type="empty" text={props.noTeamInvalidText || '抱歉，上期您未加入任何队伍。下期上午10点开始，静候您参与！'}/>

      
      <View className="team-won-free-card-buttons-container" style={{
            marginLeft: '30rpx'
        }}>
        
        <LImage source={{
            uri: TeamStageResultTheme.RewardRecordButtonNoTeam
        }} style={{
            width: '110rpx',
            height: '110rpx'
        }} onPress={props.onOpenRewardRecord} borderRadius={0}/>

        
        <LImage source={{
            uri: TeamStageResultTheme.ViewWinnerListButtonNoTeam
        }} style={{
            width: '515rpx',
            height: '110rpx'
        }} onPress={props.onOpenRewardRanking}/>
      </View>
    </View>;
    }
    return <LImage source={{
        uri: TeamStageResultTheme.BackgroundCard
    }} style={{
        width: '702rpx',
        height: '480rpx',
        marginLeft: '24rpx',
        marginRight: '24rpx'
    }} resizeMode="stretch" showAnimatioin={false}>
    <View className="team-won-free-card-title-container">
      <Text numberOfLines={1} className="team-won-free-card-title">{((_a = props.teamInfo) === null || _a === void 0 ? void 0 : _a.teamName) || '未命名小队'}</Text>

      <View className="team-won-free-card-title-container-bottom">
        <Text x-if={(_b = props.teamInfo) === null || _b === void 0 ? void 0 : _b.teamRank} className="team-won-free-card-title-container-bottom-text">
          第{(_c = props.teamInfo) === null || _c === void 0 ? void 0 : _c.teamRank}名
        </Text>

        <LImage source={{
        uri: TeamStageResultTheme.CallIcon
    }} style={{
        width: '20.8rpx',
        height: '28.2rpx',
        marginLeft: '20rpx'
    }}/>
        <Text className="team-won-free-card-title-container-bottom-text">
          {props.callValueDesc || '心愿值'}：{((_d = props.teamInfo) === null || _d === void 0 ? void 0 : _d.teamValue) || 0}
        </Text>
      </View>
    </View>

    <View className="team-won-free-card-content-container">
      <Text className="team-won-free-card-content-text">
        {getMainContentText()}
      </Text>

      <Text className="team-won-free-card-content-text-desc">
        {getDescriptionText()}
      </Text>
    </View>

    
    <View className="team-won-free-card-buttons-container">
      
      <LImage source={{
        uri: TeamStageResultTheme.RewardRecordButton
    }} style={{
        width: '110rpx',
        height: '110rpx'
    }} onPress={props.onOpenRewardRecord} borderRadius={0}/>

      
      <LImage x-if={props.teamRankingStatus === TeamRankingStatus.CALCULATING} source={{
        uri: TeamStageResultTheme.SubscribeButton
    }} style={{
        width: '382rpx',
        height: '110rpx'
    }} onPress={() => {
        var _a;
        onSubscribe(Object.assign(Object.assign({}, props.subscribeConfig), { dateTime: (_a = dayjs(props.rankingListTime)) === null || _a === void 0 ? void 0 : _a.valueOf() }));
    }}/>

      
      <LImage x-if={props.teamRankingStatus === TeamRankingStatus.WON_REWARD} onPress={props.onUseFreeCard} source={{
        uri: TeamStageResultTheme.UseButton
    }} style={{
        width: '382rpx',
        height: '110rpx'
    }}/>

      
      <LImage x-if={props.teamRankingStatus === TeamRankingStatus.PUBLICITY} source={{
        uri: TeamStageResultTheme.ViewWinnerListButton
    }} style={{
        width: '515rpx',
        height: '110rpx'
    }} onPress={props.onOpenRewardRanking}/>

      
      <LImage x-if={props.teamRankingStatus === TeamRankingStatus.WON_REWARD || props.teamRankingStatus === TeamRankingStatus.CALCULATING} onPress={props.onOpenRanking} source={{
        uri: TeamStageResultTheme.RankingButton
    }} style={{
        width: '110rpx',
        height: '110rpx'
    }} borderRadius={0}/>
    </View>
  </LImage>;
}
